import './Spinner.css'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SpinnerIcon from 'react-loader'

class Spinner extends Component {
    render() {
        const {
            spinColor,
            spinConfig,
            spinAlignment,
            ...other
        } = this.props;

        const style = {
            display: 'inline-block',
            height: '11px',
            position: 'relative',
            width: '12px',
        };

        const spinAlignmentStyle = {
            display: 'inline-block',
            float: spinAlignment + ' !important'
        };

        return (
            <div style={spinAlignmentStyle} {...other}>
                <div style={style}>
                    <SpinnerIcon {...spinConfig} color={spinColor} loaded={false} />
                </div>
            </div>
        );
    }
}

Spinner.propTypes = {
    spinColor: PropTypes.string,
    spinConfig: PropTypes.object,
    spinAlignment: PropTypes.string
}

Spinner.defaultProps = {
    spinColor: '#fff',
    spinConfig: {
        length: 4,
        lines: 15,
        radius: 3,
        width: 2,
    },
    spinAlignment: 'left'
}

export default Spinner